<template>
  <!-- 1 - Spinner -->
  <div class="loading" v-if="isLoading">
    <base-spinner></base-spinner>
  </div>
  <!-- 2 - No Match -->
  <NoMatch @toggleMatch="resetMinerals" v-if="noMatch === true" />
  <!-- 3 - Base Card -->
  <template
    v-else
    v-for="mineral in getAllMinerals.slice(0, limit)"
    :key="mineral.idName"
  >
    <MineralCard
      :main-properties="mineral"
      photo-size="miniMineralBCard"
      mode="mineralCard"
    />
  </template>
</template>

<script setup>
import NoMatch from "@/components/finder/NoMatch.vue";
import MineralCard from "./MineralCard.vue";

import { computed, ref, watch, onBeforeMount, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

// observing
let startinglimit = ref(12); // infinite scrolling
let limit = ref(); //infinite scrolling
let active = ref(true); // infinite scrolling

const isLoading = ref(false);
onBeforeMount(() => {
  getBasePage();
});

onMounted(() => {
  observing();
});

/**
 * @returns the whole page in the user language
 */
async function getBasePage() {
  isLoading.value = !isLoading.value;

  store.dispatch("minerals/getAllMinerals");
  isLoading.value = !isLoading.value;
}

/**
 * function that observes where the last element is positioned for lazy loading and infinite scrolling
 */
function observing() {
  const loading = document.querySelector(".loadingStatus");

  if (
    limit.value > getAllMinerals.value.length ||
    limit.value == getAllMinerals.value.length
  ) {
    active.value = false;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        limit.value += 8;
      }
      if (
        limit.value > getAllMinerals.value.length ||
        limit.value == getAllMinerals.value.length
      ) {
        active.value = false;
      }
    });
    // console.log("limit:" + limit.value);
    // console.log("total:" + getAllMinerals.value.length);
  });
  observer.observe(loading);
}

/**
 * @returns {Array} of rock Objects
 */
const getAllMinerals = computed(() => {
  return store.getters["minerals/getResults"];
});

watch(getAllMinerals, () => {
  active.value = true;
  limit.value = startinglimit.value;
});
/**
 * Upon closing the No Match alert, the minerals are reset
 */
function resetMinerals() {
  store.dispatch("minerals/getAllMinerals");
}
/**
 * if noMatch is true, it toggles the No Match alert
 */
const noMatch = computed(() => {
  return store.getters["minerals/getNoMatch"];
});

// function usingSlice(str, limit = 20) {
//   if (!str) return;
//   if (str.length > limit) return str.slice(0, limit) + "...";
//   return str;
// }
</script>

<style lang="css" scoped>
.details__item {
  display: flex;
  flex-direction: row;
}
.details__item--1 {
  width: 40%;
}
.details__item--2 {
  width: 60%;
  border-bottom: 1px solid var(--color-primary-3);
}
.front__identification {
  /* grid-row: 3/4; */
  margin-top: 0.5rem;
  grid-row: 2/3;
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
}
@media only screen and (max-width: 81.25em) {
  .front__identification {
    grid-row: 2/3;
    grid-column: 1/-1;
    background-color: white;
    justify-content: center;
  }
}

.front__identification--name {
  text-transform: uppercase;
  text-align: center;
  color: var(--color-home-3);
  font-weight: 1000;
}

@media only screen and (max-width: 64em) {
  .front__identification--name {
    font-size: 1.8rem;
  }
}
@media only screen and (max-width: 47.75em) {
  .front__identification--name {
    font-size: 1.6rem;
  }
}

.front__identification--symbolHtml {
  font-family: var(--font-primary);
  color: var(--color-home-3);
  font-size: 1.4rem;
  font-weight: 400;
  width: 100%;
  height: 1.5rem;
  text-overflow: ellipsis;
  text-align: center;
}

@media only screen and (max-width: 81.25em) {
  .front__identification--symbolHtml {
    display: none;
  }
}
</style>
